// extracted by mini-css-extract-plugin
module.exports = {"dateTime":"Iv3YiATgYNbyEFhqu-4fp","time":"_2aBJJgAabuXYzQK8rIujP2","date":"_2rPmj9vZiUEnD7m69LKiYj","weekDay":"_3Tfzzii88YTs7ehWkyZ47n"};